import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgImage = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g
      fill="none"
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    >
      <path d="M21.21 7.9v8.15c0 3.02-1.89 5.15-4.91 5.15H7.65c-3.02 0-4.9-2.13-4.9-5.15V7.9c0-3.02 1.89-5.15 4.9-5.15h8.65c3.02 0 4.91 2.13 4.91 5.15" />
      <path d="m5.281 16.43 1.528-1.612a1.4 1.4 0 0 1 1.98-.06l.937.952a1.434 1.434 0 0 0 2.027.02c.037-.036 2.334-2.822 2.334-2.822a1.687 1.687 0 0 1 2.375-.23c.048.04 2.218 2.268 2.218 2.268M10.313 9.133a1.754 1.754 0 1 1-3.508 0 1.754 1.754 0 0 1 3.508 0" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgImage);
export default ForwardRef;
